<template>
  <component
    :is="component"
  />
</template>

<script>
import { mapGetters } from 'vuex';

import PayoutCard from 'organisms/payout/PayoutCard';
import PayoutCrypto from 'organisms/payout/PayoutCrypto';

export default {
  name: 'Payout',
  components: {
    PayoutCard,
    PayoutCrypto,
  },
  computed: {
    component() {
      return this.isCurrencyCrypto ? 'PayoutCrypto' : 'PayoutCard';
    },
    ...mapGetters(['isCurrencyCrypto']),
  },
};
</script>
